import styled from 'styled-components';

export const CardContainer = styled.div`
  width: 100%;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
`;

export const SendToFieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  > div:first-child {
    flex: 1;
  }
`;



export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

`;
export const FromEmailContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
